import firebase from 'firebase'
import { storage } from '../firebase'

class VoiceMessageListener {

  constructor() {
    this.currentAudio = null
    this.listening = false
    this.messages = {}
    this.msgsLoaded = false
  }

  setUpMessages(messages) {

    var temp = {}

    for(var key in messages) {
      if(messages[key].messagetype === 'A') {
        temp[key] = {
          'file': null,
          'listening': false,
          'loaded': null
        }
      }
    }

    this.messages = temp
    this.msgsLoaded = true
    console.log(temp)
    console.log("setup done")

  }

  playAudio(key, msg, raceId) {
    console.log("play audio")
    console.log(this.messages)
    try {
      if(this.currentAudio) {
        console.log("Pausing and rewinding audio")
        this.messages[this.currentAudio].file.pause()
        this.messages[this.currentAudio].file.currentTime = 0
        this.messages[this.currentAudio].listening = false
      }

      this.messages[key].file.play()
      //Code catches the play and doesn't go here. If the audio hasn't been loaded yet
      this.currentAudio = key
      this.messages[key].listening = true

    } catch(err) {
      this.loadAudio(key, msg, raceId)
    }
  }

  setupAudio(key, msg, raceId) {
    //#Vuejutut, messages objecti ei ole responsiivinen jos asetetaan vain avaimia this.messages[key]
    var temp = this.messages

    temp[key] = {
      'file': null,
      'listening': false,
      'loaded': null
    }

    this.messages = temp
  }

  downloadAudio(key, msg, raceId) {
    console.log("download audio " + key)
    storage.child(raceId).child(msg).getDownloadURL().then((url) => {
      console.log(url)
      window.location.href = url
    })

  }
  loadAudio(key, msg, raceId) {
    console.log("load audio " + key)

    this.messages[key].loaded = false

    storage.child(raceId).child(msg).getDownloadURL().then((url) => {
      console.log(url)
      this.messages[key].file = new Audio(url)
      this.messages[key].loaded = true

      this.messages[key].file.addEventListener("ended", () => {
        console.log("playing " + key +  " ended");
        this.messages[key].listening = false
      })

      this.playAudio(key)

    })
  }


  stop() {
    this.listening = false
    if(this.currentAudio) {
      console.log(this.currentAudio)
      console.log("Pausing and rewinding audio")
      this.messages[this.currentAudio].file.pause()
      this.messages[this.currentAudio].file.currentTime = 0
      this.messages[this.currentAudio].listening = false
    }
  }

  clearVml() {
    this.stop()
    this.currentAudio = null
    //this.messages = {}
    this.msgsLoaded = false
  }

}

export default VoiceMessageListener
